<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" 
                modal-size="large" modal-alignment="center">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `categories/${inputs.id}` : `categories`'>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="class">{{ $t('class') }}</label>
                            <app-input id="class" type="number" v-model="inputs.class" :placeholder="$t('class')"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="level">{{ $t('level') }}</label>
                            <app-input id="level" type="number" v-model="inputs.level" :placeholder="$t('level')"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="code">{{ $t('code') }}</label>
                            <app-input id="code" type="text" v-model="inputs.code" :placeholder="$t('code')"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="tension">{{ $t('tension') }} (%)</label>
                            <app-input id="tension" type="number" v-model="inputs.tension" :placeholder="$t('tension')"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="rate">{{ $t('daily_rate') }} (CDF)</label>
                            <app-input id="rate" type="number" v-model="inputs.rate" :placeholder="$t('rate')"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="transport_fees">{{ $t('transport_fees') }} (CDF)</label>
                            <app-input id="transport_fees" type="number" v-model="inputs.transport_fees" :placeholder="$t('transport_fees')"/>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'CategoryAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {

    },
    data() {
        return {
            preloader: false,
            modalId: 'category-add-edit-modal',
            inputs: {
                class: '',
                level: '',
                code: '',
                tension: '',
                rate: '',
                transport_fees: '',
            },
            isModalActive: false,
            modalTitle: `${this.$t('new-category')}`,
        }
    },
    methods: {
        submit() {
            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>